module.exports = __webpack_public_path__ + "static/media/54.6991cdf0.jpg";